import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=2eca0ab4&scoped=true&"
import script from "./OrdersView.vue?vue&type=script&lang=js&"
export * from "./OrdersView.vue?vue&type=script&lang=js&"
import style0 from "./OrdersView.vue?vue&type=style&index=0&id=2eca0ab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca0ab4",
  null
  
)

export default component.exports